import React, { Fragment, useState, useEffect } from "react"
import Header from "../../components/Layout/Header"
// import { Link } from "gatsby"
import styled from "@emotion/styled"
import { withStoreContext } from "../../context/StoreContext"
import LoaderSpin from "../../components/LoaderSpin"
import { graphql } from "gatsby"
import {
  FooterIn,
  ListElementWrapper,
} from "../../components/Layout/Footer/styled"
import ItemBundle from "../../components/ItemBundle"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { MultipassURL } from "../../utils/multipass"
import { withUserContext } from "../../context/UserContext"
import SecurePayment from "../../../static/Logos_Payment.png"
import AlmaPaymentLogo from "../../../static/AlmaPaymentLogo.png"
import SeoComp from "../../components/SeoComp"
import {
  onCartPageScript,
  addToCartScript,
  removeFromCartScript,
} from "../../utils/additionalScriptHelpers"
import {
  productTitle,
  linkCartProduct,
  returnCartImage,
  cartEstimateDeliveryText,
} from "../../utils/cartHelpers"
import { getCount } from "../../utils/externalApiHelpers"
import { isBrowser } from "../../context/ApolloContext"
import AbandonedCartPopup from "../../components/AbandonedCartPopup"
const $ = isBrowser ? require("jquery") : {}
import { useLocation } from "@reach/router"
import { getCookie, setCheckoutID } from "../../utils/localStorageHelper"
import ReactTooltip from "react-tooltip"
import KlarnaPlacementSection from "../../components/KlarnaPlacementSection"
import { getPrice } from "../../utils/navigateToCart"
import StaticReviewSection from "../../components/StaticReviewSection"
import ExclusifItemBundle from "../../components/ExclusifItemBundle"
import CartFaqSection from "../../components/Layout/CartFaqSection"
import GiftItemBundle from "../../components/GiftItemBundle"
import CartTestimonialSection from "../../components/Layout/CartTestimonialSection"

const Cart = ({
  storeContext,
  storeContext: {
    client,
    checkout,
    addVariantToCart,
    removeLineItem,
    addDiscount,
    removeDiscount,
    applyGiftCard,
    removeGiftCard,
  },
  userContext: {
    profile: { email },
  },
  data,
  intl,
}) => {
  const [promoCode, setpromoCode] = useState("")
  const [showCouponField, setshowCouponField] = useState(false)
  const [count, setcount] = useState("130 000")
  const [activeFlag, setactiveFlag] = useState(true)
  const [activeAbandonedCartPopup, setactiveAbandonedCartPopup] = useState(
    false
  )
  const [IsMobile, setIsMobile] = useState(false)
  const [bundleTitle, setbundleTitle] = useState("")
  const [IsOfferExclusif, setIsOfferExclusif] = useState("")
  const [checkoutLoading, setcheckoutLoading] = useState(false)

  const checkDiscountApplied = () => {
    var discountApplied = false
    checkout.lineItems.forEach(item => {
      if (item.discountAllocations.length > 0) discountApplied = true
    })
    return discountApplied
  }

  const addPromo = () => {
    const giftCardRegex =
      "^[a-zA-Z0-9]{4} [a-zA-Z0-9]{4} [a-zA-Z0-9]{4} [a-zA-Z0-9]{4}$"
    var cardCheck = new RegExp(giftCardRegex)
    if (promoCode) {
      if (cardCheck.test(promoCode))
        applyGiftCard(checkout.id, promoCode, () => {
          setshowCouponField(false)
          setpromoCode("")
        })
      else
        addDiscount(checkout.id, promoCode, () => {
          setshowCouponField(false)
          setpromoCode("")
        })
    }
  }

  const removePromo = () => {
    setpromoCode("")
    removeDiscount(checkout.id)
  }

  const getQuantity = () => {
    let total = 0
    checkout.lineItems.forEach(item => (total = total + item.quantity))
    return total
  }

  const getTotalDiscount = () => {
    let total = 0
    checkout.lineItems.forEach(item => {
      item &&
        item.discountAllocations &&
        item.discountAllocations.length > 0 &&
        item.discountAllocations.forEach(itemDiscount => {
          total += Number(
            itemDiscount.discountApplication.applicable &&
              itemDiscount.allocatedAmount &&
              itemDiscount.allocatedAmount.amount
              ? itemDiscount.allocatedAmount.amount
              : 0
          )
        })
      // total += Number(
      //   itemDiscount.allocatedAmount && itemDiscount.allocatedAmount.amount
      //     ? itemDiscount.allocatedAmount.amount
      //     : 0
      // )
      // total += Number(
      //   item.discountAllocations &&
      //     item.discountAllocations.length > 0 &&
      //     item.discountAllocations[0].discountApplication.description
      //     ? item.discountAllocations[0].allocatedAmount.amount
      //     : 0
      // )
    })
    total = getPrice(total)
    return total
  }

  const getExplicitDiscount = () => {
    if (
      checkout?.discountApplications.find(
        discount => discount.targetSelection == "EXPLICIT"
      )
    ) {
      return checkout?.discountApplications.find(
        discount => discount.targetSelection == "EXPLICIT"
      )
    } else {
      return checkout?.discountApplications[0]
    }
  }

  const getCheckoutDiscounts = () => {
    let total = 0
    if (
      checkout?.discountApplications.length &&
      checkout?.discountApplications[0]?.value?.amount
    ) {
      checkout.discountApplications.forEach(
        (itemDiscount, itemDiscountIndex) => {
          total += Number(
            itemDiscount.value && itemDiscount.value.amount
              ? itemDiscount.value.amount
              : 0
          )
        }
      )
    } else {
      checkout.lineItems.forEach(item => {
        item &&
          item.discountAllocations &&
          item.discountAllocations.length > 0 &&
          item.discountAllocations.forEach(itemDiscount => {
            total += Number(
              itemDiscount.discountApplication.applicable &&
                itemDiscount.allocatedAmount &&
                itemDiscount.allocatedAmount.amount
                ? itemDiscount.allocatedAmount.amount
                : 0
            )
          })
      })
    }
    return total
  }

  const getTotalScriptDiscountApplication = () => {
    let total = 0
    checkout.lineItems.forEach(item => {
      item &&
        item.discountAllocations &&
        item.discountAllocations.length > 0 &&
        item.discountAllocations.forEach((itemDiscount, itemDiscountIndex) => {
          // if (itemDiscountIndex == 0) {
          total += Number(
            itemDiscount.allocatedAmount &&
              itemDiscount.discountApplication.title &&
              itemDiscount.allocatedAmount.amount
              ? itemDiscount.allocatedAmount.amount
              : 0
          )
          // }
        })
    })
    total = getPrice(total)
    return total
  }

  const BottomBarActive = () => {
    function isOnScreen(elem) {
      // if the element doesn't exist, abort
      if (elem.length == 0) {
        return
      }
      var $window = $(window)
      var viewport_top = $window.scrollTop()
      var viewport_height = $window.height()
      var viewport_bottom = viewport_top + viewport_height
      var $elem = $(elem)
      var top = $elem.offset().top
      var height = $elem.height()
      var bottom = top + height

      return (
        (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height &&
          top <= viewport_top &&
          bottom >= viewport_bottom)
      )
    }

    $(document).ready(function() {
      window.addEventListener("scroll", function(e) {
        if (!isOnScreen($("#checkout_button"))) {
          /* Pass element id/class you want to check */
          setactiveFlag(true)
        } else {
          setactiveFlag(false)
        }
      })
    })
  }

  const counter = async () => {
    let val
    let count = await getCount()
    if (count.status === "success") {
      val = new Intl.NumberFormat("fr-FR", { style: "decimal" }).format(
        count.data
      )
    } else
      val = new Intl.NumberFormat("fr-FR", { style: "decimal" }).format(130000)
    setcount(val)
  }

  const showBundle = () => {
    let totalQuant = 0
    checkout.lineItems.forEach(item => {
      if (
        !(
          item.title.toUpperCase().includes("GIFT-CARD") ||
          item.title.toUpperCase().includes("E-CARTE CADEAU") ||
          item.title.toUpperCase().includes("E-carte cadeau offerte")
        )
      ) {
        totalQuant += item.quantity
      }
    })
    return checkout.lineItems && totalQuant <= 2
  }

  const showCartPromotionTitle = () => {
    let totalQuant = 0
    checkout.lineItems.forEach(item => {
      if (
        !(
          item.title.toUpperCase().includes("GIFT-CARD") ||
          item.title.toUpperCase().includes("E-CARTE CADEAU") ||
          item.title.toUpperCase().includes("E-carte cadeau offerte")
        )
      ) {
        totalQuant += item.quantity
      }
    })
    return checkout.lineItems && totalQuant == 1
  }

  const showGiftBundle = () => {
    let totalQuant = 0
    checkout.lineItems.forEach(item => {
      if (
        !(
          item.title.toUpperCase().includes("GIFT-CARD") ||
          item.title.toUpperCase().includes("E-CARTE CADEAU") ||
          item.title.toUpperCase().includes("E-carte cadeau offerte")
        )
      ) {
        totalQuant += item.quantity
      }
    })
    return checkout.lineItems && totalQuant > 0
  }

  const windowResize = () => {
    var w = window.outerWidth
    if (w <= 600) {
      setIsMobile(true)
    }
    $(window).resize(() => {
      var w = window.outerWidth
      if (w <= 600) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })
  }

  const abandonedCart = () => {
    var mouseX = 0
    var mouseY = 0
    var popupCounter = 0

    if (IsMobile) {
      $(document).on("touchstart", function() {
        $("body").addClass("on-mobile-device")
      })
      function myScrollSpeedFunction() {
        if ($("body").hasClass("on-mobile-device")) {
          if (my_scroll() < -100) {
            getQuantity() > 0 && setactiveAbandonedCartPopup(true)
          }
        }
      }

      var my_scroll = (function() {
        //Function that checks the speed of scrolling
        var last_position,
          new_position,
          timer,
          delta,
          delay = 50
        function clear() {
          last_position = null
          delta = 0
        }

        clear()
        return function() {
          new_position = window.scrollY
          if (last_position != null) {
            delta = new_position - last_position
          }
          last_position = new_position
          clearTimeout(timer)
          timer = setTimeout(clear, delay)
          return delta
        }
      })()

      $(document).on("scroll", myScrollSpeedFunction)
    } else {
      document.addEventListener("mousemove", function(e) {
        mouseX = e.clientX
        mouseY = e.clientY
      })

      $(document).mouseleave(function() {
        if (mouseY < 100) {
          if (popupCounter < 1) {
            getQuantity() > 0 && setactiveAbandonedCartPopup(true)
          }
          popupCounter++
        }
      })
    }
  }
  var searchLocation = useLocation()

  const setCartToken = () => {
    const queryString = isBrowser && window.location.search
    const urlParams = new URLSearchParams(queryString)
    const cartToken = urlParams.get("cart_token")

    if (cartToken) {
      setCheckoutID(cartToken)
    }
  }

  const cummulativeDiscount = checkout => {
    var mentionPromoRegex = "^[mM]{2}[fFpP]{2}[1]{1}[a-zA-Z0-9]{6,8}$"
    var mentionPromoCheck = new RegExp(mentionPromoRegex)

    if (
      checkout.discountApplications &&
      checkout.discountApplications.length > 1 &&
      checkout.discountApplications.find(
        discountApplication =>
          discountApplication.type.name === "ScriptDiscountApplication"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "WELCOME5"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "BIENVENUE10"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "FLASH"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "KDOS10"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "CADEAU10-X472"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "CADEAU10-T216"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "CADEAU10-H584"
      ) &&
      !checkout.discountApplications.find(
        discountApplication =>
          discountApplication.code === "DISPOSITIF-MEDICAL-40-8YG56"
      ) &&
      !checkout.discountApplications.find(
        discountApplication =>
          discountApplication.code === "SUPER-OREILLER-30-XTF"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "MATELAS-30-UFG25"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "REFLEX-OSTEO"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "HIGHFIVE"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "10OUTOF10"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "PERCKO10FD"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "WOW10"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "SRPERCKO5"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "SRPERCKO10"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "SRPERCKO15"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "SRPERCKO25"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "WHATSAPP10"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "PERCKOSANTE"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "GEEZOS-EXCLU"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "FLEURALIA-EXCLU"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "PKOSTEO"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "PKQM20"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "PLUS"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "M7P8AU-10XE"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "LEQUIPE-TSHIRTPK"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "LEQUIPE-MATELASPK"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "WOW-EXCLU"
      ) &&
      !checkout.discountApplications.find(
        discountApplication => discountApplication.code === "EXCLU"
      ) &&
      !checkout.discountApplications.find(discountApplication =>
        mentionPromoCheck.test(discountApplication.code)
      ) &&
      checkout.discountApplications.find(
        discountApplication => discountApplication.applicable === true
      )
    ) {
      removeDiscount(checkout.id)
    }
  }

  const totalCartPrice = () => {
    let cartTotalPrice = checkout.subtotalPrice.amount

    checkout.appliedGiftCards &&
      checkout.appliedGiftCards.length > 0 &&
      checkout.appliedGiftCards.forEach(appliedGiftCard => {
        cartTotalPrice = cartTotalPrice - appliedGiftCard.amountUsedV2.amount
      })

    return getPrice(cartTotalPrice)
  }

  useEffect(() => {
    if (
      isBrowser &&
      getCookie("DiscountCodeApplied") &&
      (getCookie("DiscountCodeApplied").toUpperCase() === "WOW-EXCLU" ||
        getCookie("DiscountCodeApplied").toUpperCase() === "EXCLU") &&
      process.env.GATSBY_ACTIVE_ENV === "eur" &&
      intl.locale === "fr"
    ) {
      setIsOfferExclusif(getCookie("DiscountCodeApplied").toLowerCase())
    }
  }, [])

  useEffect(() => {
    counter()
    BottomBarActive()
    if (checkout.id) {
      onCartPageScript(checkout, intl.locale)
    }
    cummulativeDiscount(checkout)
  }, [checkout])

  const checkoutUrl = async () => {
    setcheckoutLoading(true)
    // if (
    //   process.env.GATSBY_CURRENCY_TYPE === "eur" &&
    //   intl.locale === "fr" &&
    //   !IsOfferExclusif &&
    //   checkout.appliedGiftCards &&
    //   checkout?.appliedGiftCards?.length == 0
    // ) {
    //   let eGiftCardExist = false
    //   let eGiftCardIdArr = []

    //   checkout.lineItems.forEach(item => {
    //     if (item.title.includes("E-carte cadeau offerte")) {
    //       eGiftCardExist = true
    //       eGiftCardIdArr.push(item.id)
    //     }
    //   })
    //   if (eGiftCardExist && eGiftCardIdArr.length > 0) {
    //     eGiftCardIdArr.forEach(async item => {
    //       await removeLineItem(item)
    //     })
    //   }

    //   let GiftCardoptions = {}
    //   let eGiftCardPrice = 0
    //   let totalCheckoutPrice = checkout.subtotalPrice.amount

    //   if (totalCheckoutPrice >= 200) {
    //     if (totalCheckoutPrice >= 800) {
    //       GiftCardoptions.Montant = "200"
    //       eGiftCardPrice = 200
    //     } else if (totalCheckoutPrice >= 600) {
    //       GiftCardoptions.Montant = "150"
    //       eGiftCardPrice = 150
    //     } else if (totalCheckoutPrice >= 400) {
    //       GiftCardoptions.Montant = "100"
    //       eGiftCardPrice = 100
    //     } else if (totalCheckoutPrice >= 350) {
    //       GiftCardoptions.Montant = "75"
    //       eGiftCardPrice = 75
    //     } else if (totalCheckoutPrice >= 250) {
    //       GiftCardoptions.Montant = "50"
    //       eGiftCardPrice = 50
    //     } else {
    //       GiftCardoptions.Montant = "15"
    //       eGiftCardPrice = 15
    //     }
    //     GiftCardoptions.Montant = `${GiftCardoptions.Montant}€`

    //     let GiftCardProduct = data.allShopifyProduct.edges.find(
    //       item => item.node.handle === "e-gift-card"
    //     ).node

    //     const GiftCardVariant = client.product.helpers.variantForOptions(
    //       GiftCardProduct,
    //       GiftCardoptions
    //     )
    //     eGiftCardIdArr = []
    //     eGiftCardExist = false

    //     await addVariantToCart(GiftCardVariant.id, 1, null)
    //   }
    // }
    let url = ""
    url = email
      ? MultipassURL({
          email: email ? email : null,
          return_to: checkout.webUrl + `&locale=${intl.locale}`,
        })
      : checkout.webUrl + `&locale=${intl.locale}`

    window.location.href = url
  }

  useEffect(() => {
    isBrowser && windowResize()
    isBrowser && abandonedCart()
  })

  useEffect(() => {
    setCartToken()
  }, [searchLocation.search])

  return data && data.allDirectusCartTranslation.nodes[0] ? (
    <Fragment>
      <SeoComp
        description={
          data.allDirectusSeoTranslation.nodes[0] &&
          data.allDirectusSeoTranslation.nodes[0].meta_description
        }
        title={
          data.allDirectusSeoTranslation.nodes[0] &&
          data.allDirectusSeoTranslation.nodes[0].meta_title
        }
        twitter_card={
          data.allDirectusSeoTranslation.nodes[0] &&
          data.allDirectusSeoTranslation.nodes[0].twitter_card
        }
        image={
          data.allDirectusSeoTranslation.nodes[0] &&
          data.allDirectusSeoTranslation.nodes[0].image &&
          data.allDirectusSeoTranslation.nodes[0].image.data &&
          data.allDirectusSeoTranslation.nodes[0].image.data.url
        }
        hreflangPathname={{ fr: "panier", en: "cart", de: "cart", es: "cart" }}
      />

      {getQuantity() > 0 &&
        activeAbandonedCartPopup &&
        (intl.locale === "fr" || intl.locale === "en") && (
          <AbandonedCartPopup />
        )}

      <LoaderSpin loading={storeContext.adding} />
      {checkout?.lineItems?.length > 0 && (
        <CheckoutSticky
          lang={(intl.locale === "fr" || intl.locale === "en") && "hide"}
          active={activeFlag}
        >
          <StickyBottomSection>
            <StickyRow>
              <StickyTotalArticle>
                {data.allDirectusCartTranslation.nodes[0].total_text
                  ? data.allDirectusCartTranslation.nodes[0].total_text
                  : "Total"}
                {" ("}
                {getQuantity()}{" "}
                {getQuantity() > 1
                  ? data.allDirectusCartTranslation.nodes[0].checkout_title
                    ? intl.locale === "de"
                      ? data.allDirectusCartTranslation.nodes[0]
                          .checkout_title + "e"
                      : data.allDirectusCartTranslation.nodes[0]
                          .checkout_title + "s"
                    : "produits"
                  : data.allDirectusCartTranslation.nodes[0].checkout_title
                  ? data.allDirectusCartTranslation.nodes[0].checkout_title
                  : "produit"}
                {")"}
              </StickyTotalArticle>
              <StickyTotalPrice>
                <CurrencySymbol
                  style={{ fontSize: "14px", fontWeight: "bold" }}
                >
                  {process.env.GATSBY_CURRENCY_TYPE !== "eur"
                    ? process.env.GATSBY_CURRENCY
                    : ""}
                </CurrencySymbol>
                {getPrice(checkout.subtotalPrice.amount)}
                <CurrencySymbol
                  style={{ fontSize: "14px", fontWeight: "bold" }}
                >
                  {process.env.GATSBY_CURRENCY_TYPE === "eur"
                    ? process.env.GATSBY_CURRENCY
                    : ""}
                </CurrencySymbol>
              </StickyTotalPrice>
            </StickyRow>
            <StickyCheckoutButton
              onClick={() => checkoutUrl()}
              checkoutLoading={checkoutLoading}
            >
              {data.allDirectusCartTranslation.nodes[0].checkout_text
                ? data.allDirectusCartTranslation.nodes[0].checkout_text
                : "VALIDER LA COMMANDE"}
            </StickyCheckoutButton>
          </StickyBottomSection>
        </CheckoutSticky>
      )}
      <CartContainer>
        {checkout?.lineItems?.length > 0 ? (
          <CartInnerContainer>
            <CartItemsContainer>
              {(intl.locale === "de" || intl.locale === "es") &&
                showCartPromotionTitle() &&
                bundleTitle && (
                  <CartNoticeCoupon
                    dangerouslySetInnerHTML={{
                      __html: bundleTitle,
                    }}
                  />
                )}
              {(intl.locale === "de" || intl.locale === "es") &&
                showCartPromotionTitle() &&
                !bundleTitle && (
                  <CartNoticeCoupon
                    dangerouslySetInnerHTML={{
                      __html:
                        data.allDirectusCartTranslation.nodes[0]
                          .two_product_text,
                    }}
                  />
                )}
              <CartTitle>
                {data.allDirectusCartTranslation.nodes[0].cart_title_text}
              </CartTitle>
              {process.env.GATSBY_ACTIVE_ENV === "eur" && intl.locale === "fr" && (
                <CartSubTitle
                  dangerouslySetInnerHTML={{
                    __html: "Prix TTC en France metropolitaine",
                  }}
                />
              )}
              <CartItemsTable>
                <CartItemsTableHeader>
                  <CartItemsTableHeaderCell
                    width={"70%"}
                    style={{ marginRight: 20 }}
                    mediaWidth={"80%"}
                    hide
                  >
                    {data.allDirectusCartTranslation.nodes[0].checkout_title
                      ? data.allDirectusCartTranslation.nodes[0].checkout_title
                      : "produit"}
                  </CartItemsTableHeaderCell>
                  <CartItemsTableHeaderCellPrice width={"15%"}>
                    {data.allDirectusCartTranslation.nodes[0].price_text
                      ? data.allDirectusCartTranslation.nodes[0].price_text
                      : "prix"}
                  </CartItemsTableHeaderCellPrice>
                  <CartItemsTableHeaderCell
                    width={"15%"}
                    mediaWidth={"20%"}
                    hide
                    style={{
                      marginLeft: 20,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {data.allDirectusCartTranslation.nodes[0].quantity_text
                      ? data.allDirectusCartTranslation.nodes[0].quantity_text
                      : "QUANTITÉ"}
                  </CartItemsTableHeaderCell>
                </CartItemsTableHeader>
                {checkout.lineItems.map((product, index) => {
                  return (
                    <div key={index.toString()}>
                      {product.variant.currentlyNotInStock ? (
                        <CartItemsOutOfStockRow>
                          {intl.formatMessage({ id: "out_of_stock_message" })}
                        </CartItemsOutOfStockRow>
                      ) : null}
                      {!product.variant.available ? (
                        <CartItemsOutOfStockRow>
                          {intl.formatMessage({
                            id: "product_not_available_message",
                          })}
                        </CartItemsOutOfStockRow>
                      ) : null}

                      <ProductRow
                        loading={storeContext.adding}
                        updateQuantityInCart={storeContext.updateQuantityInCart}
                        key={product.id.toString()}
                        product={product}
                        removeProduct={storeContext.removeLineItem}
                        intl={intl}
                        price={getPrice}
                        data={data}
                        checkout={checkout}
                        offerExclusif={IsOfferExclusif}
                      />
                    </div>
                  )
                })}
                <DivWrapper>
                  {data.allDirectusCartTranslation &&
                    data.allDirectusCartTranslation.nodes.length > 0 && (
                      <ShoppingTag
                        nohover="true"
                        style={{ border: "none" }}
                        to="/shop/"
                      >
                        {
                          data.allDirectusCartTranslation.nodes[0]
                            .continue_shopping_text
                        }
                      </ShoppingTag>
                    )}
                </DivWrapper>
                {((process.env.GATSBY_ACTIVE_ENV === "eur" &&
                  intl.locale === "fr") ||
                  process.env.GATSBY_ACTIVE_ENV === "general") &&
                  IsOfferExclusif &&
                  showBundle() && <ExclusifItemBundle data={data} />}
                {((process.env.GATSBY_ACTIVE_ENV === "eur" &&
                  intl.locale === "fr") ||
                  process.env.GATSBY_ACTIVE_ENV === "general" ||
                  process.env.GATSBY_ACTIVE_ENV === "gbp") &&
                  !IsOfferExclusif &&
                  showBundle() && <ItemBundle data={data} />}
                {/* {((process.env.GATSBY_ACTIVE_ENV === "eur" &&
                  intl.locale === "fr") ||
                  process.env.GATSBY_ACTIVE_ENV === "general") &&
                  !IsOfferExclusif &&
                  checkout.appliedGiftCards &&
                  checkout?.appliedGiftCards?.length == 0 &&
                  showGiftBundle() && <GiftItemBundle data={data} />} */}
              </CartItemsTable>
            </CartItemsContainer>
            <CartSummaryContainer>
              <CartSummaryInnerContainer>
                {/* <CartSummaryHeader>TOTAL PANIER</CartSummaryHeader> */}
                {getQuantity() > 0 && (
                  <CartSummaryHeader>
                    <CartSummaryLineItemLabel style={{ fontSize: 14 }}>
                      {getQuantity()}{" "}
                      {getQuantity() > 1
                        ? data.allDirectusCartTranslation.nodes[0]
                            .checkout_title
                          ? intl.locale === "de"
                            ? data.allDirectusCartTranslation.nodes[0]
                                .checkout_title + "e"
                            : data.allDirectusCartTranslation.nodes[0]
                                .checkout_title + "s"
                          : "Produits"
                        : data.allDirectusCartTranslation.nodes[0]
                            .checkout_title
                        ? data.allDirectusCartTranslation.nodes[0]
                            .checkout_title
                        : "Produit"}
                    </CartSummaryLineItemLabel>
                    <CartSummaryLineItemValue
                      style={{ fontSize: 18, fontFamily: "GothamLight" }}
                    >
                      <CurrencySymbol>
                        {process.env.GATSBY_CURRENCY_TYPE !== "eur"
                          ? process.env.GATSBY_CURRENCY
                          : ""}
                      </CurrencySymbol>
                      {checkout.subtotalPrice &&
                        checkout.subtotalPrice.amount &&
                        getPrice(
                          Number(checkout.subtotalPrice.amount) +
                            Number(getCheckoutDiscounts())
                        )}
                      <CurrencySymbol>
                        {process.env.GATSBY_CURRENCY_TYPE === "eur"
                          ? process.env.GATSBY_CURRENCY
                          : ""}
                      </CurrencySymbol>
                    </CartSummaryLineItemValue>
                  </CartSummaryHeader>
                )}
                <CartSummaryLineItemsContainer>
                  {checkout.discountApplications &&
                    checkout.discountApplications.length > 0 &&
                    checkout.discountApplications[0].type.name ===
                      "DiscountApplication" &&
                    getExplicitDiscount().targetSelection === "EXPLICIT" &&
                    Number(checkout.discountApplications[0].value.amount) !==
                      0 && (
                      <CartSummaryLineItemContainer style={{ border: "none" }}>
                        <CartSummaryLineItemLabel
                          style={{
                            fontFamily: "Gotham Book",
                            flex: "1",
                          }}
                        >
                          {checkout.discountApplications &&
                          checkout.discountApplications[0].title
                            ? data.allDirectusCartTranslation.nodes[0]
                                .coupon_text
                            : checkout.discountApplications[0].title
                            ? data.allDirectusCartTranslation.nodes[0]
                                .coupon_text
                            : data.allDirectusCartTranslation.nodes[0]
                                .coupon_text}
                          {/* {data.allDirectusCartTranslation.nodes[0].coupon_text
                            ? data.allDirectusCartTranslation.nodes[0]
                                .coupon_text
                            : "CODE PROMO"} */}
                          {" : "}
                          <span
                            style={{
                              textTransform: "uppercase",
                              color: "#EB213F",
                              fontWeight: "bold",
                            }}
                          >
                            {checkout.discountApplications &&
                            checkout.discountApplications[0].title
                              ? getExplicitDiscount()?.title
                              : getExplicitDiscount()?.title}
                          </span>
                        </CartSummaryLineItemLabel>
                        <CartSummaryLineItemValue
                          style={{
                            color: "#EB213F",
                            fontWeight: "bold",
                          }}
                        >
                          {checkout.discountApplications &&
                            "-" +
                              //   intl.locale === "en" ? "£" : ""
                              (process.env.GATSBY_CURRENCY_TYPE !== "eur"
                                ? process.env.GATSBY_CURRENCY
                                : "") +
                              (checkout.discountApplications[0].value &&
                                getTotalScriptDiscountApplication()) +
                              //   intl.locale === "en" ? "" : "€"
                              (process.env.GATSBY_CURRENCY_TYPE === "eur"
                                ? process.env.GATSBY_CURRENCY
                                : "")}
                          {/* {(checkout.discountApplications[0].title ||
                            checkout.discountApplications[0].code) && (
                            <RemovePromo onClick={removePromo}>
                              {"["}
                              {data.allDirectusCartTranslation.nodes[0]
                                .total_text
                                ? data.allDirectusCartTranslation.nodes[0]
                                    .remove_coupon_text
                                : "Remove"}
                              {"]"}
                            </RemovePromo>
                          )} */}
                        </CartSummaryLineItemValue>
                      </CartSummaryLineItemContainer>
                    )}
                  {/* {checkout.discountApplications &&
                    checkout.discountApplications.length > 0 &&
                    checkout.discountApplications[0].type.name ===
                      "ScriptDiscountApplication" &&
                    checkout?.discountApplications[1]?.type.name ===
                      "ScriptDiscountApplication" &&
                    Number(checkout.discountApplications[0].value.amount) !==
                      0 &&
                    Number(checkout?.discountApplications[1]?.value?.amount) !==
                      0 && (
                      <CartSummaryLineItemContainer style={{ border: "none" }}>
                        <CartSummaryLineItemLabel
                          style={{
                            color: "#EB213F",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            flex: "1",
                          }}
                        >
                          {data.allDirectusCartTranslation.nodes[0].coupon_text
                            ? data.allDirectusCartTranslation.nodes[0]
                                .apply_coupon_text
                            : "CODE PROMO"}
                          {" : "} {"FLASH"}
                        </CartSummaryLineItemLabel>
                        <CartSummaryLineItemValue
                          style={{
                            color: "#EB213F",
                            fontWeight: "bold",
                          }}
                        >
                          {checkout.discountApplications &&
                            "-" +
                              (process.env.GATSBY_CURRENCY_TYPE !== "eur"
                                ? process.env.GATSBY_CURRENCY
                                : "") +
                              // (checkout.discountApplications[0].value &&
                              //   getTotalScriptDiscountApplication()) +
                              checkout.discountApplications[1].value.amount +
                              (process.env.GATSBY_CURRENCY_TYPE === "eur"
                                ? process.env.GATSBY_CURRENCY
                                : "")}
                        </CartSummaryLineItemValue>
                      </CartSummaryLineItemContainer>
                    )} */}
                  {checkout.discountApplications.map((discount, index) => {
                    if (
                      discount.type.name === "DiscountApplication" &&
                      discount.applicable
                    ) {
                      return (
                        <CartSummaryLineItemContainer
                          style={{ border: "none" }}
                          key={`discount-${index}`}
                        >
                          <CartSummaryLineItemLabel
                            style={{
                              fontFamily: "Gotham Book",
                              flex: "1",
                            }}
                          >
                            {discount.title
                              ? data.allDirectusCartTranslation.nodes[0]
                                  .apply_coupon_text
                              : discount.code
                              ? data.allDirectusCartTranslation.nodes[0]
                                  .apply_coupon_text
                              : data.allDirectusCartTranslation.nodes[0]
                                  .coupon_text}
                            {/* {data.allDirectusCartTranslation.nodes[0].coupon_text
                            ? data.allDirectusCartTranslation.nodes[0]
                                .coupon_text
                            : "CODE PROMO"} */}
                            {" : "}
                            <span
                              style={{
                                textTransform: "uppercase",
                                color: "#EB213F",
                                fontWeight: "bold",
                              }}
                            >
                              {discount.title ? discount.title : discount.code
                              // ? checkout.discountApplications[0].code
                              // : checkout.discountApplications[0].description
                              }
                            </span>
                          </CartSummaryLineItemLabel>
                          <CartSummaryLineItemValue
                            style={{
                              color: "#EB213F",
                              fontWeight: "bold",
                            }}
                          >
                            {discount &&
                              "-" +
                                //   intl.locale === "en" ? "£" : ""
                                (process.env.GATSBY_CURRENCY_TYPE !== "eur"
                                  ? process.env.GATSBY_CURRENCY
                                  : "") +
                                (discount.value.amount > 0
                                  ? getPrice(discount.value.amount)
                                  : getTotalDiscount()) +
                                //   intl.locale === "en" ? "" : "€"
                                (process.env.GATSBY_CURRENCY_TYPE === "eur"
                                  ? process.env.GATSBY_CURRENCY
                                  : "")}
                            {(discount.title || discount.code) && (
                              <RemovePromo onClick={removePromo}>
                                {"["}
                                {data.allDirectusCartTranslation.nodes[0]
                                  .total_text
                                  ? data.allDirectusCartTranslation.nodes[0]
                                      .remove_coupon_text
                                  : "Remove"}
                                {"]"}
                              </RemovePromo>
                            )}
                          </CartSummaryLineItemValue>
                        </CartSummaryLineItemContainer>
                      )
                    }
                  })}
                  {checkout.appliedGiftCards &&
                    checkout.appliedGiftCards.length > 0 &&
                    checkout.appliedGiftCards.map((appliedGiftCard, index) => {
                      if (appliedGiftCard) {
                        return (
                          <CartSummaryLineItemContainer
                            style={{ border: "none" }}
                          >
                            <CartSummaryLineItemLabel
                              style={{
                                fontFamily: "Gotham Book",
                                color: "#EB213F",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                                wordWrap: "break-word",
                              }}
                            >
                              Gift card
                              {" : "} **** **** ****{" "}
                              {appliedGiftCard &&
                                appliedGiftCard.lastCharacters}
                            </CartSummaryLineItemLabel>
                            <CartSummaryLineItemValue
                              style={{ color: "#EB213F", fontWeight: "bold" }}
                            >
                              {appliedGiftCard &&
                                "-" +
                                  //   intl.locale === "en" ? "£" : ""
                                  (process.env.GATSBY_CURRENCY_TYPE !== "eur"
                                    ? process.env.GATSBY_CURRENCY
                                    : "") +
                                  getPrice(
                                    appliedGiftCard.amountUsedV2.amount
                                  ) +
                                  //   intl.locale === "en" ? "" : "€"
                                  (process.env.GATSBY_CURRENCY_TYPE === "eur"
                                    ? process.env.GATSBY_CURRENCY
                                    : "")}
                              <RemovePromo
                                onClick={() =>
                                  removeGiftCard(
                                    checkout.id,
                                    appliedGiftCard.id
                                  )
                                }
                              >
                                {"["}
                                {data.allDirectusCartTranslation.nodes[0]
                                  .total_text
                                  ? data.allDirectusCartTranslation.nodes[0]
                                      .remove_coupon_text
                                  : "Remove"}
                                {"]"}
                              </RemovePromo>
                            </CartSummaryLineItemValue>
                          </CartSummaryLineItemContainer>
                        )
                      }
                    })}
                  {data.allDirectusCartTranslation.nodes[0].delivery_text && (
                    <CartSummaryLineItemContainer style={{ paddingBottom: 0 }}>
                      <CartSummaryLineItemLabel
                        style={{
                          fontWeight: "500",
                          fontFamily: "Gotham Book",
                        }}
                      >
                        {process.env.GATSBY_CURRENCY_TYPE === "gbp"
                          ? "UK delivery"
                          : data.allDirectusCartTranslation.nodes[0]
                              .delivery_text.text}
                      </CartSummaryLineItemLabel>
                      <CartSummaryLineItemLabel
                        style={{
                          fontWeight: "500",
                          fontFamily: "Gotham Book",
                        }}
                      >
                        {
                          data.allDirectusCartTranslation.nodes[0].delivery_text
                            .response
                        }
                      </CartSummaryLineItemLabel>
                    </CartSummaryLineItemContainer>
                  )}
                  {data.allDirectusCartTranslation.nodes[0]
                    .delivery_partner_image && (
                    <CartSummaryLineItemContainer
                      style={{
                        borderBottom: "1px solid #d9d9d9",
                        paddingTop: 0,
                      }}
                    ></CartSummaryLineItemContainer>
                  )}
                  <CartSummaryLineItemContainer>
                    <CartSummaryLineItemLabel style={{ fontSize: 20 }}>
                      <strong>
                        {data.allDirectusCartTranslation.nodes[0].total_text
                          ? data.allDirectusCartTranslation.nodes[0].total_text
                          : "Total"}
                      </strong>
                    </CartSummaryLineItemLabel>
                    <CartSummaryLineItemValue style={{ fontSize: 18 }}>
                      <CurrencySymbol>
                        {process.env.GATSBY_CURRENCY_TYPE !== "eur"
                          ? process.env.GATSBY_CURRENCY
                          : ""}
                      </CurrencySymbol>
                      {checkout.appliedGiftCards &&
                      checkout.appliedGiftCards.length > 0
                        ? totalCartPrice()
                        : getPrice(checkout.subtotalPrice.amount)}
                      <CurrencySymbol>
                        {process.env.GATSBY_CURRENCY_TYPE === "eur"
                          ? process.env.GATSBY_CURRENCY
                          : ""}
                      </CurrencySymbol>
                    </CartSummaryLineItemValue>
                  </CartSummaryLineItemContainer>
                </CartSummaryLineItemsContainer>
                <CheckoutButton
                  id="checkout_button"
                  onClick={() => checkoutUrl()}
                  lang={intl.locale}
                  checkoutLoading={checkoutLoading}
                >
                  {data.allDirectusCartTranslation.nodes[0].checkout_text
                    ? data.allDirectusCartTranslation.nodes[0].checkout_text
                    : "VALIDER LA COMMANDE"}
                </CheckoutButton>
              </CartSummaryInnerContainer>
              <CouponWrapper>
                <CouponText
                // className={showCouponField ? "active" : ""}
                // onClick={() => setshowCouponField(!showCouponField)}
                // show={showCouponField}
                >
                  {data.allDirectusCartTranslation.nodes[0].coupon_field_title
                    ? data.allDirectusCartTranslation.nodes[0]
                        .coupon_field_title
                    : "Code promo"}
                </CouponText>
                <div
                  style={{
                    // display: !showCouponField ? "none" : "flex",
                    display: "flex",
                    transition:
                      "color 0.3s, border 0.3s, background 0.3s, opacity 0.3s,height 0.3s",
                  }}
                >
                  <CouponInput
                    show={!showCouponField}
                    placeholder={
                      data.allDirectusCartTranslation.nodes[0]
                        .coupon_field_title
                        ? data.allDirectusCartTranslation.nodes[0]
                            .coupon_field_title
                        : "Code promo"
                    }
                    onChange={e => setpromoCode(e.target.value)}
                    value={promoCode}
                  />
                  <Button
                    show={!showCouponField}
                    type="submit"
                    value={"OK"}
                    onClick={addPromo}
                  />
                </div>
                <InvalidCouponCode>
                  {checkout.discountApplications &&
                    checkout.discountApplications.length > 0 &&
                    checkout.discountApplications[0].code &&
                    !checkout.discountApplications[0].applicable &&
                    intl.formatMessage({ id: "invalid_coupon_code" })}
                </InvalidCouponCode>
              </CouponWrapper>
            </CartSummaryContainer>
          </CartInnerContainer>
        ) : (
          <NoProductSelected data={data} />
        )}
      </CartContainer>

      {data.allDirectusCartTranslation.nodes[0].secure_pay_info && (
        <SecurePayBox>
          <SecurePayDiv>
            <span>
              {data.allDirectusCartTranslation.nodes[0].secure_pay_info.text}
            </span>
            <img
              className="lazyload"
              data-src={
                process.env.GATSBY_CURRENCY_TYPE === "gbp"
                  ? SecurePayment
                  : data.allDirectusCartTranslation.nodes[0].secure_pay_info
                      .image
              }
              style={{ maxWidth: 230, margin: 0 }}
            />
          </SecurePayDiv>
          {process.env &&
            process.env.GATSBY_ACTIVE_ENV === "eur" &&
            intl.locale === "fr" && (
              <SecurePayDiv>
                <span>Payez en 2x, 3x ou 4x sans frais avec</span>
                <img
                  className="lazyload"
                  data-src={AlmaPaymentLogo}
                  style={{ maxWidth: 65, margin: "-5px 0px" }}
                />
              </SecurePayDiv>
            )}
        </SecurePayBox>
      )}

      {(intl.locale === "fr" || intl.locale === "en") &&
        data.allDirectusCartTranslation.nodes[0].testimonial_section && (
          <Patch style={{ margin: 0 }}>
            <CartTestimonialSection
              data={
                data.allDirectusCartTranslation.nodes[0].testimonial_section
              }
            />
          </Patch>
        )}

      <CartFaqSection
        data={
          process.env.GATSBY_ACTIVE_ENV === "gbp"
            ? data.allDirectusCartTranslation.nodes[0].gbp_footer_qa
            : data.allDirectusCartTranslation.nodes[0].footer_qa
        }
        title={data.allDirectusCartTranslation.nodes[0].footer_title}
      />

      <Footer>
        {data &&
          data.allDirectusFooterTranslation &&
          data.allDirectusFooterTranslation.nodes.length > 0 && (
            <FooterIn>
              {data.allDirectusFooterTranslation.nodes[0].footer_bottom.list.map(
                (item, index) => (
                  <ListElementWrapper
                    key={index.toString()}
                    style={{
                      fontSize: 10.71,
                      margin: "10px",
                    }}
                    to={item.link}
                  >
                    {item.list}
                  </ListElementWrapper>
                )
              )}
            </FooterIn>
          )}
      </Footer>
    </Fragment>
  ) : null
}

const ProductRow = ({
  product,
  updateQuantityInCart,
  removeProduct,
  intl,
  price,
  data,
  checkout,
  offerExclusif,
}) => {
  const [value, setvalue] = useState(0)

  const discountedPrice = () => {
    let quantity = product.quantity
    let discountAll = 0
    product.discountAllocations &&
      product.discountAllocations.length > 0 &&
      product.discountAllocations.map(item => {
        discountAll = Number(discountAll) + Number(item.allocatedAmount.amount)
      })
    // let discountAll =
    //   product.discountAllocations && product.discountAllocations.length > 0
    //     ? product.discountAllocations[0].allocatedAmount.amount
    //     : 0
    let discountEach = Number.isNaN(discountAll / quantity)
      ? 0
      : discountAll / quantity
    let originalPrice = product.variant.price.amount
    return originalPrice - discountEach
  }

  const handleQuantity = e => {
    const updatedQuantity = e.target.value
    updateQuantityInCart(product.id, updatedQuantity)
    setvalue(updatedQuantity)
  }

  useEffect(() => {
    setvalue(product.quantity)
  }, [product.quantity])

  return (
    <CartItemsTableRow>
      <CartItemsTableRowCell
        width={"70%"}
        mediaWidth={"80%"}
        style={{ marginRight: 10 }}
      >
        <Link
          to={linkCartProduct(
            product.title,
            product.variant,
            intl.locale,
            offerExclusif
          )}
        >
          <ProductImage
            className="lazyload"
            style={{ objectFit: product.title === "LyneHome" && "contain" }}
            data-src={
              product.title === "gift-card"
                ? returnCartImage(intl.locale)
                : product.variant.image && product.variant.image.src
            }
          />
        </Link>
        <div
          style={{ marginLeft: 20, display: "flex", flexDirection: "column" }}
        >
          <Link
            to={linkCartProduct(
              product.title,
              product.variant,
              intl.locale,
              offerExclusif
            )}
          >
            <ProductTitleText>
              {productTitle(product.title, product.variant, intl.locale)}
            </ProductTitleText>
          </Link>

          <div
            style={{
              margin: "10px 0px 0px 0px",
            }}
          >
            <ProductEstimateText>
              {cartEstimateDeliveryText(
                product.title,
                data.allDirectusCommonTranslation.nodes[0].months_text,
                intl.locale,
                product.variant.selectedOptions.find(
                  item => item.name === "Size"
                )?.value,
                product.variant.selectedOptions.find(
                  item => item.name === "Gender"
                )?.value,
                product.variant.selectedOptions.find(
                  item => item.name === "Color"
                )?.value,
                product.variant.selectedOptions.find(
                  item => item.name === "Collar"
                )?.value
              )}
            </ProductEstimateText>
          </div>
        </div>
        {/* LYNE UP – Seconde peau pour le quotidien homme – Noir, PK2 */}
      </CartItemsTableRowCell>
      <CartItemsTableRowCellPrice>
        <div style={{ display: "flex" }}>
          <CurrencySymbol style={{ fontSize: 16 }}>
            {process.env.GATSBY_CURRENCY_TYPE !== "eur"
              ? process.env.GATSBY_CURRENCY
              : ""}
          </CurrencySymbol>
          {price(discountedPrice())}
          <CurrencySymbol style={{ fontSize: 16 }}>
            {process.env.GATSBY_CURRENCY_TYPE === "eur"
              ? process.env.GATSBY_CURRENCY
              : ""}
          </CurrencySymbol>
        </div>
        {product.discountAllocations &&
          product.discountAllocations.length > 0 &&
          Number(product.discountAllocations[0].allocatedAmount.amount) !==
            0 && (
            <div style={{ display: "flex" }}>
              <StrikedText>
                <CurrencySymbol style={{ fontSize: 16 }}>
                  {process.env.GATSBY_CURRENCY_TYPE !== "eur"
                    ? process.env.GATSBY_CURRENCY
                    : ""}
                </CurrencySymbol>
                {price(product.variant.price.amount)}
                <CurrencySymbol style={{ fontSize: 16 }}>
                  {process.env.GATSBY_CURRENCY_TYPE === "eur"
                    ? process.env.GATSBY_CURRENCY
                    : ""}
                </CurrencySymbol>
              </StrikedText>
            </div>
          )}
      </CartItemsTableRowCellPrice>
      {!product.title.includes("E-carte cadeau offerte") ? (
        <CartItemsTableRowCell
          style={{
            marginLeft: 10,
            marginRight: 10,
            alignItems: "center",
            justifyContent: "flex-end",
          }}
          width={"15%"}
          mediaWidth={"20%"}
        >
          <AddRemove
            onClick={() => {
              handleQuantity({ target: { value: value - 1 } })
              removeFromCartScript(
                product.variant.product.id,
                product.title,
                product.variant,
                1,
                intl.locale
              )
            }}
            type="button"
            value="-"
          />
          <QuantitySelector
            type="number"
            value={value}
            onChange={handleQuantity}
            inputMode="numeric"
            step={1}
            size={4}
            min={0}
            max={9999}
          />
          <AddRemove
            onClick={() => {
              handleQuantity({ target: { value: value + 1 } })
              addToCartScript(
                product.variant.product.id,
                product.title,
                product.variant,
                1,
                checkout,
                intl.locale
              )
            }}
            type="button"
            value="+"
          />
        </CartItemsTableRowCell>
      ) : (
        <CartItemsTableRowCell
          style={{
            marginLeft: 10,
            marginRight: 10,
            alignItems: "center",
            justifyContent: "flex-end",
          }}
          width={"15%"}
          mediaWidth={"20%"}
        >
          <CrossDiv
            onClick={() => {
              removeProduct(product.id)
            }}
            width={"5%"}
          >
            x
          </CrossDiv>
        </CartItemsTableRowCell>
      )}
      <MobileProductCartCell flex={2.8}>
        <ProductLink
          to={linkCartProduct(
            product.title,
            product.variant,
            intl.locale,
            offerExclusif
          )}
        >
          <ProductImage
            className="lazyload"
            style={{ objectFit: product.title === "LyneHome" && "contain" }}
            data-src={
              product.title === "gift-card"
                ? returnCartImage(intl.locale)
                : product.variant.image && product.variant.image.src
            }
          />
        </ProductLink>
      </MobileProductCartCell>
      <MobileProductCartCell flex={5.5}>
        <MobileProductCartCellRight>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <ProductLink
              to={linkCartProduct(
                product.title,
                product.variant,
                intl.locale,
                offerExclusif
              )}
            >
              <ProductTitleText>
                {productTitle(product.title, product.variant, intl.locale)}
              </ProductTitleText>
            </ProductLink>

            <div
              style={{
                margin: "10px 0px 0px 0px",
              }}
            >
              <ProductEstimateText>
                {cartEstimateDeliveryText(
                  product.title,
                  data.allDirectusCommonTranslation.nodes[0].months_text,
                  intl.locale,
                  product.variant.selectedOptions.find(
                    item => item.name === "Size"
                  )?.value,
                  product.variant.selectedOptions.find(
                    item => item.name === "Gender"
                  )?.value,
                  product.variant.selectedOptions.find(
                    item => item.name === "Color"
                  )?.value,
                  product.variant.selectedOptions.find(
                    item => item.name === "Collar"
                  )?.value
                )}
              </ProductEstimateText>
            </div>
          </div>
        </MobileProductCartCellRight>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <MobileProductCartCellRight style={{ display: "flex" }}>
            <div style={{ display: "flex", fontSize: 16 }}>
              {process.env.GATSBY_CURRENCY_TYPE !== "eur"
                ? process.env.GATSBY_CURRENCY
                : ""}
              {price(discountedPrice())}
              {process.env.GATSBY_CURRENCY_TYPE === "eur"
                ? process.env.GATSBY_CURRENCY
                : ""}
            </div>
            {product.discountAllocations &&
              product.discountAllocations.length > 0 &&
              Number(product.discountAllocations[0].allocatedAmount.amount) !==
                0 && (
                <div style={{ display: "flex", fontSize: 16, marginLeft: 10 }}>
                  <StrikedText>
                    <CurrencySymbol style={{ fontSize: 16 }}>
                      {process.env.GATSBY_CURRENCY_TYPE !== "eur"
                        ? process.env.GATSBY_CURRENCY
                        : ""}
                    </CurrencySymbol>
                    {price(product.variant.price.amount)}
                    <CurrencySymbol style={{ fontSize: 16 }}>
                      {process.env.GATSBY_CURRENCY_TYPE === "eur"
                        ? process.env.GATSBY_CURRENCY
                        : ""}
                    </CurrencySymbol>
                  </StrikedText>
                </div>
              )}
          </MobileProductCartCellRight>
          <MobileProductCartCellRight>
            {!product.title.includes("E-carte cadeau offerte") ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <AddRemove
                  onClick={() => {
                    handleQuantity({ target: { value: value - 1 } })
                    removeFromCartScript(
                      product.variant.product.id,
                      product.title,
                      product.variant,
                      1,
                      intl.locale
                    )
                  }}
                  type="button"
                  value="-"
                />
                <QuantitySelector
                  type="number"
                  value={value}
                  onChange={handleQuantity}
                  inputMode="numeric"
                  step={1}
                  size={4}
                  min={0}
                  max={9999}
                />
                <AddRemove
                  onClick={() => {
                    handleQuantity({ target: { value: value + 1 } })
                    addToCartScript(
                      product.variant.product.id,
                      product.title,
                      product.variant,
                      1,
                      checkout,
                      intl.locale
                    )
                  }}
                  type="button"
                  value="+"
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <CrossDiv
                  onClick={() => {
                    removeProduct(product.id)
                  }}
                  width={"5%"}
                >
                  x
                </CrossDiv>
              </div>
            )}
          </MobileProductCartCellRight>
        </div>
      </MobileProductCartCell>
    </CartItemsTableRow>
  )
}

const NoProductSelected = ({ data }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <PromoText style={{ marginTop: 20 }}>
        {data.allDirectusCartTranslation &&
          data.allDirectusCartTranslation.nodes.length > 0 &&
          data.allDirectusCartTranslation.nodes[0].empty_cart_text}
      </PromoText>
      <EmptyCartbutton to="/shop/">
        {data.allDirectusCartTranslation &&
          data.allDirectusCartTranslation.nodes.length > 0 &&
          data.allDirectusCartTranslation.nodes[0].empty_cart_button_title}
      </EmptyCartbutton>
    </div>
  )
}

const CartContainer = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid ${props => props.theme.colors.white.light};
  flex: 1;
  @media (max-width: 900px) {
    padding: 10px 10px;
  }
`

const CartInnerContainer = styled.div`
  width: 100%;
  max-width: 730px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0px 0px;
`

const CartItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
  flex: 0.6;
  width: 100%;
  > p {
    color: #212121;
    font-size: 16px;
    font-weight: bold;
    font-family: "GothamLight";
  }
  @media (max-width: 900px) {
    width: 100%;
    flex: initial;
    padding: 10px;
  }
`

const CartTitle = styled.h1`
  color: #262626;
  font-size: 16px;
  font-weight: bold;
  font-family: "GothamLight";
  margin: 0px;
`

const CartSubTitle = styled.div`
  color: #c1b8b8;
  font-size: 12px;
  font-weight: bold;
  font-family: "GothamLight";
  margin-bottom: 20px;

  @media (max-width: 600px) {
    margin-bottom: 0px;
  }
`

const CartItemsTable = styled.div`
  display: flex;
  flex-direction: column;
`

const CartNoticeCoupon = styled.div`
  padding: 10px 0;
  font-size: 15px;
  color: #7a9c59;
  font-weight: bold;
`

const CartItemsTableHeader = styled.div`
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #d9d9d9;
`

const CartItemsTableHeaderCell = styled.h2`
  display: flex;
  width: ${props => props.width || "auto"};
  color: #262626;
  font-size: 14px;
  margin-bottom: 0px;
  font-family: "GothamLight";

  @media (max-width: 600px) {
    width: ${props => props.mediaWidth || "auto"};
    font-size: 11.5px;
    display: ${({ hide }) => (hide ? "none" : "flex")};
  }
`

const CartItemsTableRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px;
  border-bottom: 1px solid #d9d9d9;
  flex: 1;
  position: relative;

  @media (max-width: 600px) {
    padding: 0px;
  }
`

const CartItemsOutOfStockRow = styled.div`
  width: 100%;
  color: #fbb42e;
  font-weight: bold;
  padding: 10px 10px 0 10px;

  a {
    color: #fbb42e;
    text-decoration: underline;
  }

  a:hover {
    color: #fbb42e;
    text-decoration: underline;
  }

  @media (max-width: 600px) {
    padding: 0px;
  }
`

const CartItemsTableRowCell = styled.div`
  display: flex;
  width: ${props => props.width || "auto"};
  align-items: center;
  font-family: "GothamLight";
  color: #262626;

  > a {
    :hover {
      font-weight: bold;
    }

    @media (max-width: 600px) {
      width: ${props => props.mediaWidth || "auto"};
      > span {
        display: none;
      }
    }
  }

  @media (max-width: 600px) {
    display: none;
  }
`

const CartSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0.4;
  /* padding: 20px; */
  padding-right: 30px;
  padding-left: 30px;
  @media (max-width: 900px) {
    flex: 1;
    width: 100%;
    margin: auto;
    padding: 0 10px;
  }
`

const CartSummaryHeader = styled.div`
  display: flex;
  font-size: 15px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 10px;
  padding: 10px 0;
  justify-content: space-between;
  align-items: center;
`

const CartSummaryLineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const CartSummaryInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  border: 1px solid #d9d9d9;
  margin: 20px 0px;
`

const CartSummaryLineItemContainer = styled.div`
  display: flex;
  padding: 10px 0;
  justify-content: space-between;

  &:last-child {
    margin-bottom: 20px;
  }

  .__react_component_tooltip {
    background: linear-gradient(
      42.57deg,
      rgb(165, 250, 183) 0%,
      rgb(0, 196, 193) 52.23%,
      rgb(80, 181, 213) 93.37%
    );
    color: #262626;
    max-width: 300px;
    border-radius: 40px 0px;
    border-width: 0px;
    border-color: inherit;
    padding: 20px;
    font-family: "Gotham Book";
    font-size: 14px;
  }

  .__react_component_tooltip.show {
    opacity: 1;
  }
  .__react_component_tooltip.place-left:after {
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    right: -6px;
    top: 50%;
    margin-top: -4px;
    border-left-color: #5db9bc;
    border-left-style: solid;
    border-left-width: 6px;
  }
  .__react_component_tooltip.place-right:after {
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    left: -6px;
    top: 50%;
    margin-top: -4px;
    border-right-color: #5db9bc;
    border-right-style: solid;
    border-right-width: 6px;
  }
  .__react_component_tooltip.place-top:after {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    bottom: -6px;
    left: 50%;
    margin-left: -8px;
    border-top-color: #5db9bc;
    border-top-style: solid;
    border-top-width: 6px;
  }
  .__react_component_tooltip.place-bottom:after {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    top: -6px;
    left: 50%;
    margin-left: -8px;
    border-bottom-color: #5db9bc;
    border-bottom-style: solid;
    border-bottom-width: 6px;
  }
`

const CartSummaryLineItemLabel = styled.div`
  display: flex;
  align-items: center;
  font-family: "Gotham Book";

  span {
    margin-left: 4px;
  }
`

const CartSummaryLineItemValue = styled.div`
  display: flex;
  font-weight: bold;
  align-items: center;
`

const CheckoutButton = styled.button`
  width: 100%;
  background: #262626;
  color: #fff;
  border: 0px;
  padding: 10px 0;
  font-family: "Museo";
  font-weight: 900;
  font-size: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;

  @media (max-width: ${({ lang }) =>
      lang === "fr" || lang === "en" ? "0px" : "600px"}) {
    position: fixed;
    bottom: 0px;
    left: 0px;
    margin: 0px;
    padding: 10px 0px;
  }

  :after {
    content: "";
    animation: productAddToCartLoader 1.3s infinite linear;
    border: 2px solid #fff;
    border-right-color: rgba(0, 0, 0, 0);
    border-radius: 16px;
    box-sizing: border-box;
    display: ${({ checkoutLoading }) => (checkoutLoading ? "block" : "none")};
    overflow: hidden;
    width: 18px;
    height: 18px;
    position: absolute;
    margin: 0px;
    top: 10px;
    left: 10px;
  }
`

const QuantitySelector = styled.input`
  display: flex;
  width: 32px;
  text-align: center;
  color: ${props => props.theme.colors.black.light};
  border-radius: 0px;
  padding: 5px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin: 0px;
  /* -webkit-appearance: none; */
  background-color: #fff;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
  @media (max-width: 600px) {
    width: 25px;
    font-size: 1em;
    padding: 2px;
    height: 30px;
  }
`

const ProductImage = styled.img`
  width: 300px;
  max-height: 110px;
  object-fit: cover;
  align-self: center;
  margin: 0;
  max-width: 125px;

  @media (max-width: 600px) {
    padding: 0px;
    margin: 0px;
    width: 100%;
    position: relative;
    max-width: 100px;
    max-height: 100px;
  }
`

const AddRemove = styled.input`
  /* width: 20px; */
  padding: 5px;
  cursor: pointer;
  border-radius: 0px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin: 0px;
  @media (max-width: 600px) {
    font-size: 0.97em;
    padding: 0 5.5px;
    height: 30px;
  }
`

const RemovePromo = styled.span`
  color: #334862;
  font-size: 12px;
  cursor: pointer;
  margin-left: 5px;
`

const PromoText = styled.p`
  font-weight: 400;
  font-size: 11px;
  color: ${props => props.theme.colors.text.promo};
  font-family: "GothamLight";
  --primary-color: #262626;
`

const Footer = styled.div`
  display: block;
  height: auto;
`

const ProductLink = styled(Link)`
  display: flex;
  align-items: center;
`

const EmptyCartbutton = styled(Link)`
  background-color: #262626;
  margin-bottom: 1em;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: bolder;
  text-align: center;
  color: #fff;
  border-color: rgba(0, 0, 0, 0.05);
  text-rendering: optimizeLegibility;
  box-sizing: border-box;
  border-radius: 0;
  padding: 10px 15px;
  margin-top: 3em;
  :hover {
    color: #fff;
  }
`

const Patch = styled.div`
  display: flex;
  margin: 20px 0px 0px 0px;
  flex-direction: row;

  @media (max-width: 600px) {
    flex-direction: column;
    > div {
      margin-bottom: 10px;
      font-size: 12px;
    }
  }
`

const ShoppingTag = styled(Link)`
  border: 2px solid #d9d9d9;
  background-color: transparent;
  line-height: 2.19em;
  margin-bottom: 1em;
  padding: 10px 5px;
  font-family: "GothamLight";
  font-size: 12px;
  text-transform: uppercase;
  :hover {
    background-color: ${({ nohover }) => (nohover ? "" : "#262626")};
    color: ${({ nohover }) => (nohover ? "" : "#fff")};
  }
`

const DivWrapper = styled.div`
  margin-top: 5px;
`

const CurrencySymbol = styled.span`
  margin-top: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Gotham Book";
`

const SecurePayBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  max-width: 730px;

  @media (max-width: 600px) {
    flex-direction: column;
    margin: 0px 0px 20px;
  }

  > span {
    margin-bottom: 5px;
    font-family: "GothamLight";
    font-weight: 500;
    font-size: 14px;
  }
`

const SecurePayDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0px 20px;

  @media (max-width: 600px) {
    margin: 10px 0px;
  }

  > span {
    margin-bottom: 5px;
    font-family: "GothamLight";
    font-weight: 500;
    font-size: 14px;
  }
`

const CouponWrapper = styled.div``

const CouponText = styled.div`
  font-family: "Gotham Book";
  color: #262626;
  font-weight: bold;
  font-size: 14px;
  margin: 0px;
  cursor: pointer;
`

const CouponInput = styled.input`
  height: ${({ show }) => !show && "0px"} !important;
  background-color: #ede9e8 !important;
  border-radius: 0px;
  color: #0e1116;
  padding: 0 12px;
  box-sizing: border-box;
  padding: 0 0.75em;
  height: 2.507em;
  font-size: 0.97em !important;
  border-radius: 0;
  max-width: 100%;
  width: 100%;
  vertical-align: middle;
  background-color: #fff;
  color: #333;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: color 0.3s, border 0.3s, background 0.3s, opacity 0.3s,
    height 0.3s;
  border: ${({ show }) => (show ? "1px solid #ddd" : "none")};
  font-family: "GothamLight";
  margin-bottom: 0px;
`

const InvalidCouponCode = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 10px;
`

const Button = styled.input`
  display: ${({ show }) => (!show ? "none" : "block")} !important;
  overflow: hidden;
  position: relative;
  background-color: #f9f9f9;
  text-shadow: 1px 1px 1px #fff;
  color: #666;
  border: 1px solid #ddd;
  text-transform: none;
  font-weight: 400;
  width: 60px !important;
  overflow: hidden;
  background-color: #f9f9f9;
  text-shadow: 1px 1px 1px #fff;
  color: #666;
  border-radius: 0;
  margin: 10px 0px 20px;
  line-height: 2.4em;
  min-height: 2.5em;
  padding: 0 1.2em;
  max-width: 100%;
  transition: all 0.3s linear;
  text-rendering: optimizeLegibility;
  box-sizing: border-box;
  border: ${({ show }) => (show ? "1px solid #ddd" : "none")};
  margin-bottom: 0px;
  cursor: pointer;
  :hover {
    background: #ede9e8;
  }
`

const CartItemsTableHeaderCellPrice = styled.h2`
  display: flex;
  width: ${props => props.width || "auto"};
  color: #262626;
  font-size: 14px;
  margin-bottom: 0px;
  font-family: "GothamLight";
  @media (max-width: 600px) {
    display: none;
    width: 0px;
    font-size: 11.5px;
  }
`
const CartItemsTableRowCellPrice = styled.div`
  display: flex;
  width: 15%;
  align-items: flex-start;
  font-family: "Gotham Book";
  color: #262626;
  justify-content: center;
  font-weight: 500;
  flex-direction: column;
  font-size: 16px;

  @media (max-width: 600px) {
    display: none;
    width: 0px;
  }
`

const MobileProductCartCell = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: flex;
    flex: ${({ flex }) => flex || 1};
    flex-direction: column;
    padding: 10px 0px;

    span {
    }
  }
`

const MobileProductCartCellRight = styled.div`
  padding: 5px;
  font-size: 16px;
`

const StrikedText = styled.div`
  position: relative;
  color: #797979;

  ::before {
    position: absolute;
    content: "";
    border-top: 1px solid;
    border-color: inherit;
    left: 50%;
    top: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
  }
`

const CheckoutSticky = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0px;
  z-index: 4;
  padding: 0px;
  background: #fff;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 0 rgba(0, 0, 0, 0.07),
    inset 0 0 0 1px rgba(0, 0, 0, 0.05);
  display: ${({ lang, active }) => (lang && active ? "flex" : "none")};
  flex-direction: column;
`

const StickyBottomSection = styled.div`
  width: 100%;
  max-width: 730px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
`

const StickyRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`

const StickyTotalArticle = styled.div`
  font-family: "Gotham Book";
  font-size: 14px;
  text-transform: capitalize;
`

const StickyTotalPrice = styled.div`
  font-family: "Gotham";
  font-weight: bold;
  font-size: 14px;
`

const ProductTitleText = styled.div`
  font-size: 14px;
  line-height: 1.2;
  color: #262626;
  font-family: "Gotham Book";
  font-weight: 500;
`

const ProductEstimateText = styled.div`
  font-size: 14px;
  line-height: 1.2;
  color: #262626;
  font-family: "Gotham Book";
  font-weight: 500;
`

const StickyCheckoutButton = styled.button`
  width: 100%;
  background: #262626;
  color: #fff;
  padding: 10px 0px;
  border: 0px;
  font-family: "Museo";
  font-weight: 900;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  position: relative;

  :after {
    content: "";
    display: none;
    animation: productAddToCartLoader 1.3s infinite linear;
    border: 2px solid #fff;
    border-right-color: rgba(0, 0, 0, 0);
    border-radius: 16px;
    box-sizing: border-box;
    display: ${({ checkoutLoading }) => (checkoutLoading ? "block" : "none")};
    overflow: hidden;
    width: 18px;
    height: 18px;
    position: absolute;
    margin: 0px;
    left: 10px;
    top: 8px;
  }
`

const CrossDiv = styled.div`
  display: flex;
  width: ${props => props.width || "auto"};
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.2;
  border: 2px solid #959595;
  color: #959595;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  margin: auto;
  cursor: pointer;
  font-family: "Gotham Book";

  :hover {
    color: #262626;
    border: 2px solid #262626;
  }
`

export const query = graphql`
  query($lang: String!) {
    allDirectusCartTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        empty_cart_button_title
        empty_cart_text
        eur_promotional_text {
          items
        }
        promotional_text {
          items
        }
        footer_qa {
          items {
            question
            answer
          }
        }
        gbp_footer_qa {
          items {
            question
            answer
          }
        }
        footer_title
        coupon_text
        remove_coupon_text
        checkout_text
        subtotal_text
        total_text
        checkout_title
        apply_coupon_text
        coupon_field_title
        bottom_patches {
          items {
            image
            text
            title
          }
        }
        continue_shopping_text
        secure_pay_info {
          image
          text
        }
        delivery_info_one
        delivery_info_two
        quantity_text
        price_text
        delivery_text {
          text
          response
        }
        estimate_text
        delivery_partner_image
        cart_title_text
        two_product_text
        cart_bundle_title
        cart_bundle_section {
          list {
            name
            image
            image_alt
            logo_image
            logo_title
            logo_alt
            tag
            title
            button_text
            button_url
          }
        }
        gift_bundle_section {
          list {
            name
            image
            image_alt
            title
            button_text
            button_url
          }
        }
        exclusif_cart_bundle_section {
          list {
            name
            image
            image_alt
            logo_image
            logo_title
            logo_alt
            tag
            title
            button_text
            button_url
          }
        }
        cart_bundle_lyneup_title
        cart_bundle_lyneup_bestseller
        cart_bundle_loop_title
        cart_bundle_loop_new
        cart_bundle_lynefit_title
        cart_bundle_lynefit_bestseller
        cart_bundle_lynehome_title
        cart_bundle_lynehome_bestseller
        cart_bundle_add_to_cart_button_text
        cart_bundle_star_title
        cart_bundle_star_text
        testimonial_section {
          title
          subtitle
          list {
            image
            text
            mobile_text
            popup_text
          }
        }
      }
    }
    allDirectusFooterTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        facebook
        gbp_facebook
        youtube
        twitter
        instagram
        linkedin
        about_us {
          name
          list {
            link
            list
          }
        }
        contact {
          name
          list {
            link
            list
          }
          button {
            link
            list
          }
        }
        purchases {
          list {
            list
            link
          }
          name
        }
        help {
          list {
            link
            list
          }
          name
        }
        about_us_menu {
          name
          list {
            link
            list
          }
        }
        knowledge_center_menu {
          name
          list {
            link
            list
          }
        }
        shop_menu {
          name
          list {
            link
            list
          }
        }
        support_menu {
          name
          list {
            link
            list
          }
          button {
            link
            list
          }
        }
        newsletter_heading
        follow_us_heading
        footer_bottom {
          list {
            link
            list
          }
        }
      }
    }
    allShopifyProduct(sort: { order: ASC, fields: handle }) {
      edges {
        node {
          id: storefrontId
          createdAt
          updatedAt
          descriptionHtml
          description
          handle
          productType
          title
          vendor
          publishedAt
          options {
            id
            name
            values
          }
          variants {
            id: storefrontId
            title
            price
            weight
            sku
            image {
              id
              src: originalSrc
              #   altText
            }
            selectedOptions {
              name
              value
            }
          }
          images {
            src: originalSrc
            id
          }
          priceRangeV2 {
            minVariantPrice {
              amount
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
    allDirectusHomeTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        customer_servcie_text
      }
    }
    allDirectusLyneupTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        product_title
        product_title_logo_image {
          data {
            url
          }
        }
        product_bestseller_text
        product_images_section {
          default_image
          men {
            noir
            nude
          }
          women {
            noir
            nude
          }
        }
        product_material_info
        product_add_to_cart_button
        product_blue_banner_text
        product_result_section {
          section_title
          list {
            title
            mobile_title
            text
          }
        }
        product_why_choose_section {
          section_title
          mobile_section_title
          slider {
            image
            title
            text
          }
          text_list {
            image
            text
            mobile_text
          }
        }
        product_expert_section {
          section_title
          mobile_section_title
          list {
            image
            name
            designation
            text
            video_text
            video_url
          }
        }
        product_satisfied_client_section {
          title
          mobile_title
          subtitle
          left_text {
            title
            text
          }
          right_text {
            title
            text
            link
            link_url
          }
        }
        product_video_testimonial {
          title
          subtitle
          testimonials {
            title
            author
            thumb
            video
          }
        }
        product_faq_section {
          title
          subtitle
          list {
            question
            answer {
              image
              mobile_image
              text
            }
          }
        }
        product_companies_logo_slider {
          title
          subtitle
          list
        }
        size {
          item
        }
        color {
          item
        }
        choose_gender_text
        gender {
          item
        }
        male_size_chart {
          data {
            url
          }
        }
        female_size_chart {
          data {
            url
          }
        }
        price_details
        size_popup_text
        language
        my_custom_size_text
        one_size_system_text
        morphology_text
        i_calculate_text
        most_suited_text
        edit_my_information_text
        return_text
        alma_popup_text
      }
    }
    allDirectusReviewTranslation(
      filter: {
        review: { product: { regex: "/loop|lyneup|lynefit/" } }
        language: { eq: $lang }
      }
    ) {
      nodes {
        author_name
        review_text
        place_and_date
        review {
          product
          stars
          name
        }
      }
    }
    allDirectusCommonTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        testimonials {
          list {
            image
            text
          }
        }
        medicale_text
        medicale_logo {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        months_text {
          month
        }
      }
    }
    allDirectusHomeTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        customer_servcie_text
      }
    }
    allDirectusLoopTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        product_title
        product_title_logo_image {
          data {
            url
          }
        }
        product_material_info
        product_info
        product_loop_info
        product_add_to_cart_button
        product_banner_text
        why_choose_slider {
          section_title
          mobile_section_title
          section_subtitle
          slider {
            image
            title
            text
          }
        }
        loop_technology_title
        loop_technology_subtitle
        loop_technology_desktop_image {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1080, quality: 100)
            }
            extension
          }
        }
        loop_technology_mobile_image {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 250, quality: 100)
            }
            extension
          }
        }
        loop_technology_mobile_slider {
          data
        }
        loop_technology_text {
          technology {
            title
            text
          }
        }
        loop_message_desktop_image {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
            extension
          }
        }
        loop_message_mobile_image {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 490, quality: 100)
            }
            extension
          }
        }
        loop_message_text
        loop_message_button_text
        price_details
        product_faq_section {
          title
          subtitle
          list {
            question
            answer {
              text
            }
          }
        }
        language
      }
    }
    allDirectusLynefitTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        product_title
        product_title_logo_image {
          data {
            url
          }
        }
        product_images_section {
          default_image
          men {
            noir
            bleu
          }
          women {
            noir
            bleu
          }
        }
        product_material_info
        product_add_to_cart_button
        product_blue_banner_text
        product_result_section {
          section_title
          list {
            title
            mobile_title
            text
          }
        }
        product_why_choose_section {
          section_title
          mobile_section_title
          slider {
            image
            title
            text
          }
          text_list {
            image
            text
            mobile_text
          }
        }
        product_expert_section {
          section_title
          mobile_section_title
          list {
            image
            name
            designation
            text
            video_text
            video_url
          }
        }
        product_satisfied_client_section {
          title
          mobile_title
          subtitle
          left_text {
            title
            text
          }
          right_text {
            title
            text
            link
            link_url
          }
        }
        product_video_testimonial {
          testimonials {
            title
            author
            thumb
            video
          }
        }
        product_faq_section {
          title
          subtitle
          list {
            question
            answer {
              image
              mobile_image
              text
            }
            open
          }
        }
        gbp_product_faq_section {
          title
          subtitle
          list {
            question
            answer {
              image
              mobile_image
              text
            }
            open
          }
        }
        size {
          Male
          Female
        }
        color {
          item
        }
        choose_gender_text
        gender {
          item
        }
        language
        price_details
        my_custom_size_text
        one_size_system_text
        alma_popup_text
        size_chart_text
        male_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1200, quality: 100)
            }
          }
        }
        female_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1200, quality: 100)
            }
          }
        }
        male_desktop_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        male_mobile_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        female_desktop_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        female_mobile_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        size_popup_text
      }
    }
    allDirectusLyneHomeTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        product_title
        product_title_logo
        product_title_logo_image {
          data {
            url
          }
        }
        product_add_to_cart_button
        size {
          Male
          Female
        }
        color {
          item
        }
        choose_gender_text
        gender {
          item
        }
        male_desktop_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        male_mobile_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        female_desktop_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        female_mobile_size_chart {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
      }
    }
    allDirectusMatelasTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        banner_slider {
          list {
            image
            alt
          }
        }
        title
        subtitle
        description
        add_to_cart_button
        dimensions_text
        product_size {
          list {
            size
            value
          }
        }
        combo_section {
          single_product_text
          offer_title
          offer_text
          offer_second_text
        }
        black_friday_combo_section {
          single_product_text
          offer_title
          offer_text
          offer_second_text
        }
        alma_popup_text
      }
    }
    allDirectusSeoTranslation(
      filter: { language: { eq: $lang }, seo: { page_name: { eq: "panier" } } }
    ) {
      nodes {
        meta_title
        meta_description
        twitter_card
        twitter_title
        url
        image {
          data {
            url
          }
        }
      }
    }
  }
`

export default injectIntl(withStoreContext(withUserContext(Cart)))
